import { Observable, of } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { map, tap } from "rxjs/operators";
var CommonService = /** @class */ (function () {
    function CommonService(http) {
        var _this = this;
        this.http = http;
        this.jobMacroStudyTags = null;
        this._jobFromUrl = null;
        console.log("common loaded", new Date().getTime());
        this.http
            .get(environment.baseUrlWs +
            environment.wsVerison +
            "employer/job-macro-study-tags")
            .toPromise()
            .then(function (r) { return (_this.jobMacroStudyTags = r); });
    }
    CommonService.prototype.getData = function (dataType) {
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "employer/" +
            dataType +
            "/?all=1");
    };
    CommonService.prototype.getSectors = function () {
        return this.http.get(environment.baseUrlWs + environment.wsVerison + "employer/sectors/?all=1");
    };
    CommonService.prototype.getTypes = function () {
        return this.http.get(environment.baseUrlWs + environment.wsVerison + "employer/types/?all=1");
    };
    CommonService.prototype.getCountries = function () {
        return this.http.get(environment.baseUrlWs + environment.wsVerison + "employer/countries");
    };
    CommonService.prototype.getCities = function (country_id) {
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "employer/countries/" +
            country_id +
            "/cities");
    };
    CommonService.prototype.getUniversities = function (idCity) {
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "employer/cities/" +
            idCity +
            "/universities");
    };
    CommonService.prototype.getFaculties = function () {
        return this.http.get(environment.baseUrlWs + environment.wsVerison + "employer/faculty-tags");
    };
    CommonService.prototype.getUniversityByName = function (name) {
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "universities?name=" +
            name);
    };
    CommonService.prototype.getSkillsByName = function (name) {
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "skills_by_name?name=" +
            name);
    };
    CommonService.prototype.getCitiesByName = function (name) {
        return this.http.get(environment.baseUrlWs + environment.wsVerison + "cities?name=" + name);
    };
    CommonService.prototype.getLanguagesByName = function (name) {
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "employer/languages?name=" +
            name);
    };
    CommonService.prototype.getLanguageLevels = function (language_id) {
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "language_levelss?id=" +
            language_id);
    };
    CommonService.prototype.isImgFromFb = function (img) {
        if (!img) {
            return false;
        }
        return img.indexOf("scontent.xx") > -1 || img.indexOf("lookaside") > -1;
    };
    CommonService.prototype.setApplicationViewed = function (id) {
        return this.http.put(environment.baseUrlWs +
            environment.wsVerison +
            "employer/jobs/" +
            id +
            "/curriculum-set-viewed", {});
    };
    CommonService.prototype.setCheckInViewed = function (id) {
        return this.http.put(environment.baseUrlWs +
            environment.wsVerison +
            "employer/events/" +
            id +
            "/check-in-set-viewed", {});
    };
    CommonService.prototype.setEmployersUsersViewed = function (users_id) {
        return this.http.put(environment.baseUrlWs +
            environment.wsVerison +
            "employer/curricula/set-viewed/" +
            users_id, {});
    };
    CommonService.prototype.getIndustriesByName = function (name) {
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "industries_by_name?name=" +
            name);
    };
    CommonService.prototype.getGeolocations = function (query) {
        var _params = new HttpParams();
        if (query) {
            _params = _params.append("query", query);
        }
        _params = _params.append("page", '0');
        _params = _params.append("limit", '500');
        return this.http
            .get(environment.baseUrlWs + environment.wsVerison + "employer/retrieve-geolocations", { params: _params });
    };
    CommonService.prototype.getStudyTags = function (name) {
        if (name === void 0) { name = null; }
        var _params = new HttpParams();
        if (name) {
            _params = _params.append("name_en", name);
        }
        return this.http
            .get(environment.baseUrlWs + environment.wsVerison + "employer/study-tags", { params: _params });
    };
    CommonService.prototype.getJobStudyTags = function (name) {
        if (name === void 0) { name = null; }
        var _params = new HttpParams();
        if (name) {
            _params = _params.append("name_en", name);
        }
        return this.http
            .get(environment.baseUrlWs + environment.wsVerison + "employer/study-tags", { params: _params })
            .pipe(map(function (r) { return (r = r.list); }), tap(function (r) { return console.log(r); }), tap(function (r) { return r.map(function (e) { return (e.name = e.name_en); }); }), tap(function (r) { return console.log(r); }));
    };
    CommonService.prototype.getJobMacroStudyTag = function (name) {
        if (name === void 0) { name = null; }
        var _params = new HttpParams();
        if (name) {
            _params = _params.append("name", name);
            return this.http.get(environment.baseUrlWs +
                environment.wsVerison +
                "employer/job-macro-study-tags", { params: _params });
        }
        else {
            return of(this.jobMacroStudyTags);
        }
    };
    CommonService.prototype.getJobCountries = function (query) {
        if (query === void 0) { query = null; }
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/job-countries";
        var _params = new HttpParams();
        if (query) {
            _params = _params.append("query", query);
        }
        return this.http.get(url, { params: _params });
    };
    CommonService.prototype.getAddresses = function (query, language) {
        if (language === void 0) { language = "en"; }
        var url = "" + environment.baseUrlWs + environment.wsVerison + "/employer/addresses";
        var params = new HttpParams();
        params = params.append("address", query);
        // params = params.append("language", language);
        return this.http.get(url, { params: params });
    };
    CommonService.prototype.getJobUniversities = function (name, country_ids) {
        if (name === void 0) { name = null; }
        var _params = new HttpParams();
        if (country_ids && country_ids.length > 0) {
            country_ids.forEach(function (c) {
                _params = _params.append("countries_ids", String(c.id));
            });
        }
        if (name) {
            _params = _params.append("name", name);
        }
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "employer/job-universities", { params: _params });
    };
    CommonService.prototype.getEnhancements = function () {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/enhancements";
        return this.http.get(url);
    };
    CommonService.prototype.getBenefits = function () {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/benefits";
        return this.http.get(url);
    };
    CommonService.prototype.getLanguages = function () {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/languages";
        return this.http.get(url);
    };
    CommonService.prototype.getGeolocationsByJobId = function (id, page, limit, query) {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/geolocations/job-offers/" + id + "/?limit=" + limit + "&page=" + page + "&query=" + query;
        return this.http.get(url);
    };
    CommonService.prototype.getGeolocationsByExperienceId = function (id, page, limit, query) {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/geolocations/webinars/" + id + "/?limit=" + limit + "&page=" + page + "&query=" + query;
        return this.http.get(url);
    };
    CommonService.prototype.getInstitutesFromJobOfferId = function (jobOfferId, query, page, limit) {
        if (page === void 0) { page = 0; }
        if (limit === void 0) { limit = 20; }
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/institutes/job-offers/" + jobOfferId + "?limit=" + limit + "&page=" + page + "&query=" + query;
        return this.http.get(url);
    };
    CommonService.prototype.getStudyTagsFromJobOfferId = function (jobOfferId, query, page, limit) {
        if (page === void 0) { page = 0; }
        if (limit === void 0) { limit = 20; }
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/job-study-tags/" + jobOfferId + "?limit=" + limit + "&page=" + page + "&name=" + query;
        return this.http.get(url);
    };
    CommonService.prototype.getTagsFromJobOfferId = function (jobOfferId, query, page, limit) {
        if (page === void 0) { page = 0; }
        if (limit === void 0) { limit = 20; }
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/tags/job-offers/" + jobOfferId + "?limit=" + limit + "&page=" + page + "&query=" + query;
        return this.http.get(url);
    };
    CommonService.prototype.getJobFromUrl = function (jobOfferUrl) {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/jobs/job-from-url";
        return this.http.post(url, { url: jobOfferUrl });
    };
    Object.defineProperty(CommonService.prototype, "jobFromUrl", {
        get: function () {
            return this._jobFromUrl;
        },
        set: function (data) {
            this._jobFromUrl = data;
        },
        enumerable: true,
        configurable: true
    });
    return CommonService;
}());
export { CommonService };
